import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MembershipStatus } from '@core/api/generated/api-client';
import { membershipStatusLabels } from '@core/api/enums/membership-status.labels';

@Component({
  selector: 'app-membership-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './membership-status-badge.component.html',
  styleUrl: './membership-status-badge.component.scss'
})
export class MembershipStatusBadgeComponent {
  @Input() status?: MembershipStatus | null;

  get label(): string | null {
    if (!this.status) return null;
    return membershipStatusLabels[this.status] ?? this.status;
  }
}
